import { lighten, Stack, SxProps } from "@mui/material"
import { Button, Typography } from "@cakemail-org/ui-components-v2"
import { TBanner } from "./types"

export function Banner({ text, cta, ctaTxt, content, sx = {} }: TBanner) {
    return <Stack direction="row" justifyContent="center" alignItems="center" gap={4} flexWrap="nowrap" className="banner-component"
        sx={(theme) => {
            return {
                padding: theme.spacing(4),
                background: lighten(theme.palette.secondary.main, 0.9),
                width: "100%",
                ...sx
            }
        }}
    >
        {content}
        {text && <Typography>{text}</Typography>}
        {cta && <Button size="small" onClick={cta} variant="outlined" color="body1" name="emailAPIBannerCTA">{ctaTxt}</Button>}
    </Stack>
}